// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__wj5nD","slide":"Gallery_slide__7m7T2","nav":"Gallery_nav__4zfKp","navPrev":"Gallery_navPrev__-2QBg","navNext":"Gallery_navNext__Ccw5o"};